// extracted by mini-css-extract-plugin
export default {"button_common":"Base_button_common__+pGh7","error":"Base_error__g512h"};